import React from 'react';
import styled from 'styled-components';
import { Flex } from '../Flex/Flex';
import { getPaletteColor } from '../utils/utils';
const SwatchColor = /*#__PURE__*/styled.div.withConfig({
  displayName: "Swatch__SwatchColor",
  componentId: "sc-1erk7qq-0"
})(["height:24px;width:24px;background-color:", ";border-radius:50%;border:1px solid ", ";display:flex;margin:4px;cursor:", ";"], props => props.color, getPaletteColor('border.base'), props => props.onClick ? 'pointer' : 'default');
/**
 * @public
 */
export function Swatch({
  colors,
  onClick,
  ...props
}) {
  return React.createElement(Flex, {
    flexWrap: 'wrap',
    ...props
  }, colors.map((color, idx) => React.createElement(SwatchColor, {
    "data-testid": `${idx}-${color}`,
    key: `${idx}-${color}`,
    color: color,
    onClick: onClick ? () => onClick(color) : undefined
  })));
}
Swatch.displayName = 'Swatch';